import { g as getPriceRange } from "../../../chunks/utils.js";
const load = async () => {
  const prices = getPriceRange();
  return {
    prices
  };
};
export {
  load
};
